import LoadingBox from 'components/Common/Loading/LoadingBox'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import PriceRowMerchandisePriceStackingLoadingSkeleton from 'LuxKit/PricePoints/Merchandise/PriceRowMerchandisePriceStackingLoadingSkeleton'

const Card = styled.div`
  display: grid;
  gap: ${rem(16)};
  grid-template-columns: 1fr;
  grid-template-rows: ${rem(240)} 1fr;

  ${mediaQueryUp.tablet} {
    grid-template-rows: ${rem(270)} 1fr;
  }
`

function MerchandiseCardSkeleton() {
  return <Card>
    <LoadingBox />
    <VerticalSpacer gap={16}>
      <VerticalSpacer gap={8}>
        <TextLoadingBox typography="body-small" width="10ch" />
        <TextLoadingBox typography="body-large" width="100%" lines={2} />
      </VerticalSpacer>
      <PriceRowMerchandisePriceStackingLoadingSkeleton size="L" direction="horizontal" />
    </VerticalSpacer>
  </Card>
}

export default MerchandiseCardSkeleton
